import { render, staticRenderFns } from "./VueGradientWrapper.vue?vue&type=template&id=358bdfa1&"
import script from "./VueGradientWrapper.vue?vue&type=script&lang=ts&"
export * from "./VueGradientWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./VueGradientWrapper.vue?vue&type=style&index=0&id=358bdfa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports